import React from "react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface ButtonPrimaryProps {
  children: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
}

export function ButtonPrimary({
  children,
  className,
  size = "lg",
  onClick,
  href,
  disabled = false,
}: ButtonPrimaryProps) {
  const baseClasses =
    "bg-gothia-green border-2 border-gothia-green text-white hover:bg-gothia-green/90 hover:border-gothia-green/90 transition-all duration-300 font-body font-semibold shadow-md hover:shadow-lg hover:scale-105";

  const sizeClasses = {
    sm: "text-sm px-4 py-2 rounded-lg w-40",
    lg: "text-lg px-8 py-4 rounded-full w-80",
  };

  const buttonElement = (
    <Button
      size={size === "md" ? "sm" : size}
      className={cn(
        baseClasses,
        sizeClasses[size === "md" ? "sm" : size],
        className,
      )}
      onClick={onClick}
      disabled={disabled}>
      {children}
    </Button>
  );

  if (href) {
    return <a href={href}>{buttonElement}</a>;
  }

  return buttonElement;
}
